// @ts-nocheck
import { Items } from "@pdfking/tfunc"
import { is_element } from "./is_element"
import { is_iterator } from "./is_iterator"
import { is_object } from "./is_object"
import { to_array } from "./to_array"

/**
 * Iterates over iterable applying function for side effects.
 *
 * Like forEach but works with objects, iterators, and arrays.
 * Function receives (value, key/index).
 *
 * @param f - Function to apply for each element
 * @param iterable - Array, object, iterator, or primitive
 *
 * @example
 * ```ts
 * import { scan } from "@pdfking/rfunc"
 *
 * scan((v, i) => console.log(v, i), [1, 2, 3])
 * scan((v, k) => console.log(k, v), { a: 1, b: 2 })
 * ```
 */
export const scan = (f, iterable) => {
  if (is_iterator(iterable)) {
    let index = 0
    for (const value of iterable) {
      f(value, index)
      index++
    }
  } else if (is_object(iterable) && !is_element(iterable)) {
    Items(iterable).forEach(([k, v]) => f(v, k))
  } else {
    to_array(iterable).forEach(f)
  }
}
